










































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { quizPlayerEventBus } from '@/main';
import { List, Enumerable } from 'linq-collections';
import { ExChoiceListItemVm, ExChoiceList, ElementSaveStateVm } from '@/interfaces/ExDataSet';
import { ExerciseVM } from "@/interfaces/ExerciseVM";

const globals = namespace("globals");
const quizplayerstore = namespace("quizplayerstore");

@Component({
  components: {
  }
})
export default class CompMultipleChoice extends Vue {
  @Prop() guid!: string;
  @Prop() choiceList!: ExChoiceList;
  @Prop() finalized!: boolean;
  @Prop() preset!: boolean;
  @Prop() text!: string;
  @Prop() textArray!: string[];
  @Prop() size!: string; // 24, evtl.: x-small, small, medium, large, x-large
  @Prop() color!: string;
  @Prop() weight!: string; // lighter, normal, bold, bolder, 100,200,300,400,500,600,700,800,900
  @Prop() fontStyle!: string; // normal, italic, oblique

  @quizplayerstore.Action setElementState!: (saveState: ElementSaveStateVm) => void;
  @quizplayerstore.Action getElementState!: (settings: string) => Promise<string | null>;
  @globals.Getter selectedExercise!: ExerciseVM | null;

  // showSuccessCheck: boolean = false;
  // showFailedCheck: boolean = false;

  $refs!: {
    radioButton: any;
  };

  async mounted() {
    if (this.choiceList.items) {
      // Try to load existing state for this element
      let saveState = await this.getElementState(this.guid);
      if (saveState) {
        // Apply the loaded settings
        const selectedIds = JSON.parse(saveState);
        this.choiceList.items?.forEach(item => {
          item.selected = selectedIds.includes(item.id);
        });
      }

      // Randomize the order of the choices
      if (this.selectedExercise?.randomizeQuestionOptions ?? false) {
        // console.log("Randomizing choices for multiple choice");
        this.choiceList.items = new List(this.choiceList.items).orderBy(x => Math.random()).toArray();
      }

      this.$store.commit("quizplayerstore/setChoiceState",
        { id: this.choiceList.id, questionId: this.choiceList.questionId, isRight: this.allChoicesRightAnswered, selectionLable: this.selectedLabels }
      );
      quizPlayerEventBus.$emit("changed:score", { questionId: this.choiceList.questionId, score: this.score });

      if (saveState) {
        await this.$globalHelper.delay(); // Give the verify button time to appear
        quizPlayerEventBus.$emit("verify", true);
      }

      // Ensure DOM is updated and then focus the first choice
      // await this.$globalHelper.delay(300);
      // this.focusChoiceItem(0);
    }
  }


  handleKeyNavigation(event: KeyboardEvent, currentIndex: number) {
    if (!this.choiceList?.items || this.choiceList.items.length === 0) return;

    let targetIndex = -1;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        event.preventDefault();
        targetIndex = currentIndex + 1;
        if (targetIndex >= this.choiceList.items.length) {
          targetIndex = 0; // Wrap to first item
        }
        break;

      case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) {
          targetIndex = this.choiceList.items.length - 1; // Wrap to last item
        }
        break;

      case 'Home':
        event.preventDefault();
        targetIndex = 0;
        break;

      case 'End':
        event.preventDefault();
        targetIndex = this.choiceList.items.length - 1;
        break;

      default:
        return; // Don't handle other keys
    }

    // Focus the target item
    this.focusChoiceItem(targetIndex);
  }

  focusChoiceItem(index: number) {
    const listItems = this.$el.querySelectorAll('.dc-mpc');
    // console.log("focusListItem: index=", index, " listItems.length=", listItems.length);
    if (listItems[index]) {
      (listItems[index] as HTMLElement).focus();
    }
  }

  // focusFirstElement() {
  //   // focus the first choice using the generic focusChoice helper
  //   this.focusChoice(0);
  // }

  // // Fokus auf eine bestimmte Choice-Index setzen (robust für Vue-Komponenten oder HTMLElements)
  // focusChoice(index: number) {
  //   const arr = this.$refs.choices as any[] | undefined;
  //   if (!arr || !arr.length) {
  //     console.log("[CompMultipleChoice] focusChoice - no refs.choices");
  //     return;
  //   }
  //   if (index < 0 || index >= arr.length) {
  //     // out of bounds: ignore
  //     return;
  //   }

  //   const target = arr[index];
  //   if (!target) return;

  //   // If Vue component instance, try its $el
  //   if (target.$el && typeof target.$el.focus === "function") {
  //     try { (target.$el as HTMLElement).focus(); return; } catch { /* ignore */ }
  //   }

  //   // If raw HTMLElement
  //   // if (typeof (target as any).focus === "function") {
  //   //   try { (target as any).focus(); return; } catch { /* ignore */ }
  //   // }

  //   // last resort: find a focusable descendant
  //   // try {
  //   //   const el = target.$el ? (target.$el as HTMLElement) : (target as HTMLElement);
  //   //   const focusable = el && el.querySelector ? el.querySelector<HTMLElement>('[tabindex], button, a, input, textarea') : null;
  //   //   if (focusable) focusable.focus();
  //   // } catch { /* ignore */ }
  // }

  // onKeyUp(currentIndex: number) {
  //   const prev = currentIndex - 1;
  //   if (prev >= 0) {
  //     this.focusChoice(prev);
  //   }
  // }

  // onKeyDown(currentIndex: number) {
  //   const arr = this.$refs.choices as any[] | undefined;
  //   const length = arr ? arr.length : 0;
  //   const next = currentIndex + 1;
  //   if (next < length) {
  //     this.focusChoice(next);
  //   }
  // }

  // onKeyHome(/* currentIndex: number */) {
  //   // move focus to first item
  //   this.focusChoice(0);
  // }

  // onKeyEnd(/* currentIndex: number */) {
  //   // move focus to last item
  //   const arr = this.$refs.choices as any[] | undefined;
  //   const last = arr && arr.length ? arr.length - 1 : 0;
  //   this.focusChoice(last);
  // }

  @Watch("finalized")
  onFinalizedChanged(val: boolean) {
    // Do not save state if scoring is required. So the question can be re-answered.
    if (this.selectedExercise?.requiredScoreValue ?? 0 > 0) {
      console.log("Not saving state because scoring is required.");
      return;
    }

    if (val) {
      // Create an array with all ids of selected choices
      const selectedIds = this.choiceList.items?.filter(item => item.selected).map(item => item.id) ?? [];

      this.setElementState( {
          guid: this.guid,
          settings: JSON.stringify(selectedIds)
        } as ElementSaveStateVm
      );
    }
  }

  get allChoicesRightAnswered() {
    return this.choiceList.items?.every(item => item.isRight && item.selected || !item.isRight && !item.selected) ?? false;
  }

  get selectedLabels() {
    let labels = this.choiceList.items?.filter(item => item.selected).map(item => item.label) ?? [];
    return labels.join(';');
  }

  get score(): number {
    const items = this.choiceList.items ?? [];
    const len = items.length > 0 ? items.length : 1;
    const correctCount = items.filter(item => (item.isRight && item.selected) || (!item.isRight && !item.selected)).length;
    let score = Math.round((correctCount * 100) / len);
    if (!isFinite(score) || isNaN(score)) score = 0;
    score = Math.max(0, Math.min(100, score)); // ensure 0..100
    return score;
  }

  onItemClicked(item: ExChoiceListItemVm, index?: number) {
    if (this.finalized) return;

    // toggle selection
    item.selected = !item.selected;
    this.$store.commit("quizplayerstore/setChoiceState",
      { id: this.choiceList.id, questionId: this.choiceList.questionId, isRight: this.allChoicesRightAnswered, selectionLable: this.selectedLabels }
    );
    quizPlayerEventBus.$emit("changed:score", { questionId: this.choiceList.questionId, score: this.score });

    // restore focus to the clicked choice (if index provided)
    if (typeof index === "number") {
      this.focusChoiceItem(index!);
    }
  }

  get fontSize() {
    if (this.size == null)
      return "18px";
    if (isNaN(Number(this.size))) // Number(this.size) != NaN)
      return this.size;
    return this.size + "px";
  }

  get lineHeight() {
    let fs = this.fontSize.replace("px", "");
    if (isNaN(Number(fs)))
      return this.fontSize;

    return Number(fs) + 2 + "px";
  }

  get hyperText() {
    if (this.text != null)
      return this.text;
    if (this.textArray != null)
      return this.textArray.join('');

    return null;
  }

  get backgroundColor() {
    if (this.$vuetify.theme.dark) {
      return "#ffffff30";
    }

    return "#ffffff80";
  }

  getBorderStyle(item: ExChoiceListItemVm) {
    if (!this.finalized)
      return "width: 100%;";
    if (!item.isRight && item.selected || item.isRight && !item.selected)
      return "border: 2px solid #f4433680; width: calc(100% - 32px);";
    if (item.isRight && item.selected)
      return "border: 2px solid #00b00080; width: calc(100% - 32px);";
    return "width: calc(100% - 32px);";
  }

  get checkBoxColor() {
    if (this.$vuetify.theme.dark)
      return "#ffffff";

    return "#000000a0";
  }

  get statusMessage() {
    if (!this.finalized) {
      return "";
    }

    if (!this.choiceList.items) {
      return "";
    }

    const selectedItems = this.choiceList.items.filter(item => item.selected);
    const correctSelections = selectedItems.filter(item => item.isRight);
    const incorrectSelections = selectedItems.filter(item => !item.isRight);
    const missedCorrectAnswers = this.choiceList.items.filter(item => item.isRight && !item.selected);

    let message = "";

    if (correctSelections.length > 0) {
      message += `Richtig ausgewählt: ${correctSelections.map(item => item.label).join(", ")}. `;
    }

    if (incorrectSelections.length > 0) {
      message += `Falsch ausgewählt: ${incorrectSelections.map(item => item.label).join(", ")}. `;
    }

    if (missedCorrectAnswers.length > 0) {
      message += `Richtige Antworten nicht ausgewählt: ${missedCorrectAnswers.map(item => item.label).join(", ")}. `;
    }

    if (this.allChoicesRightAnswered) {
      message += "Alle Antworten sind korrekt!";
    }

    return message;
  }
}
